export default __webpack_public_path__ + "static/media/percentOfEvaluationImage.5ae0df2e.png";